<template>
  <div>
    <DropDown type="domain" :title="selectedDomainActual">
      <template v-slot:items>
        <DropDownItem
          v-for="domain of domainsActual"
          type="domain"
          :text="domain"
          :value="domain"
          :key="domain"
          @selectItem="selectItem"
        />
        <li class="add-site-item" @click="openAddDomain">
          <div class="add-site-content">
            <span class="add-site-icon">+</span>
            <span>{{ $t('buttons.addSite') }}</span>
          </div>
        </li>
      </template>
    </DropDown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DropDown from '@/components/shared/drop-down/DropDown.vue'
import DropDownItem from '@/components/shared/drop-down/DropDownItem.vue'

export default {
  data() {
    return {}
  },
  components: {
    DropDown,
    DropDownItem,
  },
  props: ['type'],
  computed: {
    ...mapGetters(['domains', 'selectedDomain']),
    selectedDomainActual() {
      return this.selectedDomain
    },
    domainsActual() {
      return this.domains.filter(item => {
        return item !== this.selectedDomainActual || this.domains.length <= 1
      })
    },
  },
  methods: {
    ...mapActions(['changeSelectedDomain']),
    selectItem(value) {
      this.changeSelectedDomain(value)
    },
    openAddDomain() {
      this.$store.dispatch('addDomainModal/show')
    },
  },
}
</script>

<style scoped>
.add-site-item {
  font-size: 14px;
  line-height: 19px;
  color: var(--main-color);
  border-radius: 7px;
  display: flex;
  cursor: pointer;
  border-top: 1px solid var(--border-color);
  margin-top: 4px;
  padding-top: 4px;
}

.add-site-item:hover {
  background-color: var(--bg-hover);
}

.add-site-content {
  padding: 0.375rem 0.75rem;
  width: 100%;
  white-space: nowrap;
}

.add-site-icon {
  margin-right: 6px;
  font-weight: 600;
}
</style>
